import "moment/locale/pt-br";

import * as routes from "../../utils/contants/urls";
import * as urlsApi from "../../utils/contants/urlsApi";

import {  buildErroHandleItems, buildPagination} from "../../helpers/sharedHelpers";
import { put, select, takeLatest } from "redux-saga/effects";

import API from "../../utils/API";
import { Types as MessageTypes } from "../ducks/messages";
import { Types } from "../ducks/contracts";
import moment from "moment";

moment.locale("pt-BR");

const filterCandidates = payload => {
  const body = {
    nomeFuncionario: payload.nomeFuncionario,
    cpfList: payload.cpfList,
    idVagasList: payload.idVagasList,
    idLocaisList: payload.idLocaisList,
    idStatusList: payload.idStatusList,
    dataAdmissaoPrevista: payload.dataAdmissaoPrevista,
    dataInicioAtividade: payload.dateInitActivity,
    numeroPagina: payload.NumeroPagina,
    quantidadeItens: payload.quantidadeItens
  };

  return body;
};

function requestCandidadesFromVacancyList(body) {
  return API.put(
    `${urlsApi.REQUEST_CANDIDATES_VACANCY_CONTRACT}`,
    body
  )
    .then(res => res.data)
    .catch(error => {
      throw error;
    });
}

function* getCandidatesVacancyDocs({ payload }) {
  try {
    let actualPage;
    if (payload && payload.firstPage) {
      actualPage = 1;
    } else {
      actualPage = payload.NumeroPagina || (yield select(getActualPage));
    }
    let actualItens = payload && payload.recoveredFilter && payload.quantidadeItens ? payload.quantidadeItens : 50;
    payload.quantidadeItens = actualItens;
    payload.NumeroPagina = actualPage;

    const { lista, paginacao } = yield requestCandidadesFromVacancyList(filterCandidates(payload));

    const candidates = {
      candidatos: lista.candidatosNaEtapaList.map(e => ({
        cpf: e.cpf,
        idCandidatoNaEtapa: e.idCandidatoNaEtapa,
        idVaga: e.idVaga,
        nome: e.nome,
        statusCandidatoNaEtapa: e.statusCandidatoNaEtapa,
        tituloVaga: e.tituloVaga
      })),
      candidatosPorVaga: lista.candidatosNaEtapaPorVagaList.map(e => ({
        idVaga: e.idVaga,
        nomeVaga: e.nomeVaga,
        candidatesByVacancyList: e.candidatosNaEtapaList.map(c => ({
          cpf: c.cpf,
          idCandidatoNaEtapa: c.idCandidatoNaEtapa,
          idVaga: c.idVaga,
          nome: c.nome,
          statusCandidatoNaEtapa: c.statusCandidatoNaEtapa,
          tituloVaga: c.tituloVaga
        }))
      }))
    };

    const stateCandidateList = yield select(getStateCandidatesList);
    let candidatos = candidates.candidatos;

    let candidatosPorVaga = candidates.candidatosPorVaga;

    const AllCandidates = {
      candidatos: candidatos,
      candidatosPorVaga: candidatosPorVaga
    }

    const paginacaoNumber = { ...paginacao, page: payload.NumeroPagina }

    const pagination = buildPagination(
      paginacaoNumber,
      payload,
      AllCandidates.candidatos,
      stateCandidateList,
      50,
    )

    yield put({
      type: Types.CANDIDATES_VACANCYS_CONTRACTS_SUCCESS,
      candidates: AllCandidates,
      pagination,
    });
  } catch (error) {
    const messages = buildErroHandleItems(error.response)
    yield put({ type: MessageTypes.MESSAGE_PUBLICATION, messages });
    yield put({ type: Types.CANDIDATES_VACANCYS_CONTRACTS_FAIL, error });
  }
}
const getActualPage = state => state.contracts?.page;
const getStateCandidatesList = state => state.contracts?.candidates;
function requestCandidadeFilesList(id) {
  return API.get(
    `${urlsApi.REQUEST_CANDIDATES_CONTRACT_FILES}?idCandidatoEmEtapa=${id}`

  )
    .then(res => res.data)
    .catch(error => { throw error });
}
function requestTypesContract() {
  return API.get(
    `${urlsApi.REQUEST_TYPES_CONTRACT}`

  )
    .then(res => res.data)
    .catch(error => { throw error });
}




function* getTypesContract() {
  try {
    const typesContract = yield requestTypesContract();



    const tipoContratoList = typesContract.tipoContratos.map(e => ({
      id: e.id,
      name: e.nome
      }));


    yield put({
      type: Types.TYPE_CONTRACTS_SUCCESS,
      tipoContratoList

    });
  } catch (error) {
    const messages = buildErroHandleItems(error.response)
    yield put({ type: MessageTypes.MESSAGE_PUBLICATION, messages });
    yield put({ type: Types.TYPE_CONTRACTS_FAIL, error });
  }
}


function* getCandidateFiles({ payload }) {
  try {
    const candidateDocs = yield requestCandidadeFilesList(payload.id);



    const candidatesFiles = convertContract(candidateDocs);


    yield put({
      type: Types.CANDIDATE_FILES_SUCCESS,
      candidatesFiles

    });
  } catch (error) {
    yield put({ type: Types.CANDIDATE_FILES_FAIL, error });
  }
}


function requestSetStatusFile(payload) {
  return API.put(
    `${urlsApi.SET_CANDIDATES_CONTRACT_STATUS}`,
    { IdDocumento: payload.idDocumento, IdCandidatoEmEtapa: payload.idCandidatoEmEtapa, Status: parseInt(payload.status), messageParaCandidato: payload.message }
  )
    .then(res => res.data)
    .catch(error => {
      throw error;
    });
}

function* setStatusContractFiles({ payload }) {
  try {
    const candidateDocs = yield requestSetStatusFile(payload);

    window.location.href = `${routes.CONTRACT_CANDIDATE}/${payload.idCandidatoEmEtapa}`;

  } catch (error) {
    const messages = buildErroHandleItems(error.response)
    yield put({ type: MessageTypes.MESSAGE_PUBLICATION, messages });
    yield put({ type: Types.CANDIDATE_SET_STATUS_FILE_FAIL, error });
  }
}







function requestSetStatusStage(payload) {
  return API.get(
    `${urlsApi.CONTRACT_CONFIRM_STAGE}?idCandidatoEtapa=${payload.id}&dispensarCandidato=${payload.dispensar}&observacao=${payload.observacao}`
  )
    .then(res => res.data)
    .catch(error => {
      throw error;
    });
}

function* setStatusContractStage({ payload }) {
  try {
    const candidateDocs = yield requestSetStatusStage(payload);

    window.location.href = `${routes.CONTRACT_CANDIDATE}/${payload.id}`;

  } catch (error) {
    yield put({ type: Types.CANDIDATE_SET_STATUS_STAGE_FAIL, error });
  }
}



function convertContract(candidateDocs) {

  return {
    nome: candidateDocs.nome,
    idCandidatoEtapa: candidateDocs.idCandidatoEmEtapa,
    statusEtapa: candidateDocs.statusEtapa,
    podeConfirmar: candidateDocs.podeConfirmar,
    podeEditar: candidateDocs.podeEditar,
    podeSubstituirOuInserirArquivoContrato: candidateDocs.podeSubstituirOuInserirArquivoContrato,
    idVaga: candidateDocs.idVaga,
    cpf: candidateDocs.cpf,
    podeReAnalisarEtapa: candidateDocs.podeReAnalisarEtapa,
    divergencia:candidateDocs.divergencia,
    kit:candidateDocs.kit,
    filesList: candidateDocs.contratos ? candidateDocs.contratos.map(e => ({
      Id: e.id,
      url_contratoAssinado: e.url_contratoAssinado,
      url_contrato: e.url_contrato,
      nome: e.nome,
      status: e.status,
      instrucao: e.descricao,
      divergencia: e.divergencia,

      type: e.tipo
    })) : [],
    filesBaseList: candidateDocs.documentosPossiveisDeEnvio ? candidateDocs.documentosPossiveisDeEnvio.map(e => ({
      Id: e.id,
      descricao: e.descricao,
      nome: e.nome,
      tipoDocumento: e.tipoDocumento
    })) : [],

  };
}


function requestChangeKitContToCandidate(payload) {
  let dataSend = {cpf: payload.cpf, candidatoPerfilAssinaturaDocumentos_Id: payload.tipoContrato };
  return API.put(
    `${urlsApi.CHANGE_KIT_CONTRACT}`,dataSend
  )
    .then(res => res.data)
    .catch(error => {
      throw error;
    });
}

function requestNewContToCandidate(payload) {
  let dataSend = {cpfslist: payload.cpfs, tipoValidacao: payload.tipoContrato };
  return API.put(
    `${urlsApi.SET_NEW_CONTRACT}`,dataSend
  )
    .then(res => res.data)
    .catch(error => {
      throw error;
    });
}
function* setNewKitContractToCandidate({ payload }) {
  try {
     yield requestChangeKitContToCandidate(payload);
     window.location.href = `${routes.CONTRACT_CANDIDATE}/${payload.id}`;
    yield put({
      type: Types.CANDIDATE_CHANGE_KIT_CONTRACT_SUCCESS,
    });

  } catch (error) {
    const messages = buildErroHandleItems(error.response)
    yield put({ type: MessageTypes.MESSAGE_PUBLICATION, messages });
    yield put({ type: Types.CANDIDATE_CHANGE_KIT_CONTRACT_FAIL, error });
  }
}

function* setNewContractToCandidate({ payload }) {
  try {
    const logProcess =  yield requestNewContToCandidate(payload);

    yield put({
      type: Types.CANDIDATE_INCLUDE_NEW_CONTRACT_SUCCESS,
      logProcess
    });

  } catch (error) {
    const messages = buildErroHandleItems(error.response)
    yield put({ type: MessageTypes.MESSAGE_PUBLICATION, messages });
    yield put({ type: Types.CANDIDATE_INCLUDE_NEW_CONTRACT_FAIL, error });
  }
}

function requestchangeContractCandidate(payload) {

  let formImg = new FormData();
  formImg.append("contratoFile", payload.file);
  formImg.append("idCandidateEmEtapa", payload.idCandidateEmEtapa);
  return API.put(`${urlsApi.CHANGE_CONTRACT}`, formImg)
    .then(res => res.data)
    .catch(error => {
      throw error;
    });
}

function* changeContractToCandidate({ payload }) {
  try {
    yield requestchangeContractCandidate(payload);
    yield put({
      type: Types.CANDIDATE_CHANGE_CONTRACT_SUCCESS,
    });
    payload.id=payload.idCandidateEmEtapa;
    yield getCandidateFiles({ payload: payload });
  } catch (error) {
    const messages = buildErroHandleItems(error.response)
    yield put({ type: MessageTypes.MESSAGE_PUBLICATION, messages });
    yield put({ type: Types.CANDIDATE_CHANGE_CONTRACT_FAIL, error });
  }
}


function requestChangeContractWithError(payload) {

  let formImg = new FormData();
  formImg.append("novoContrato", payload.file);
  formImg.append("IdCandidatoEmEtapa", payload.idCandidatoEmEtapa);
  formImg.append("messageParaCandidato", payload.messageParaCandidato);

  return API.put(`${urlsApi.CHANCE_CONTRACT_WITH_ERROR}`, formImg)
    .then(res => res.data)
    .catch(error => {
      throw error;
    });
}




function* ChangeContractWithError({ payload }) {
  try {
    yield requestChangeContractWithError(payload);



    window.location.href = `${routes.CONTRACT_CANDIDATE}/${payload.idCandidatoEmEtapa}`;


  } catch (error) {
    const messages = buildErroHandleItems(error.response);
    yield put({ type: Types.CANDIDATE_FILES_FAIL, error });
    yield put({
      type: Types.CANDIDATE_DOCUMENT_RESEND_FAIL,
      error
    });
  }
}


export function* watcherSaga() {
  yield takeLatest(Types.CANDIDATES_VACANCYS_CONTRACTS_REQUEST, getCandidatesVacancyDocs);
  yield takeLatest(Types.CANDIDATE_CONTRACT_REQUEST, getCandidateFiles);
  yield takeLatest(Types.CANDIDATE_SET_STATUS_CONTRACT_FILE_REQUEST, setStatusContractFiles);
  yield takeLatest(Types.TYPE_CONTRACTS_REQUEST, getTypesContract);
  yield takeLatest(Types.CANDIDATE_INCLUDE_NEW_CONTRACT_REQUEST, setNewContractToCandidate);
  yield takeLatest(Types.CANDIDATE_CHANGE_KIT_CONTRACT_REQUEST, setNewKitContractToCandidate);


  yield takeLatest(Types.CANDIDATE_CONTRACT_SET_STATUS_STAGE_REQUEST, setStatusContractStage);



  yield takeLatest(Types.CANDIDATE_CONTRACT_RESEND_REQUEST, ChangeContractWithError);

  yield takeLatest(Types.CANDIDATE_CHANGE_CONTRACT_REQUEST, changeContractToCandidate);



}
